export default __webpack_public_path__ + "static/media/businesscons.2af92f0a.png";